import React from 'react';
import { Section } from './ui/Section';
import { CTAButton } from './ui/CTAButton';
export function ProductRevealSection() {
  return <Section className="text-center" data-id="element-161">
      <p className="text-[#b8a9c9] uppercase tracking-widest text-sm font-bold mb-4" data-id="element-162">
        Introducing
      </p>
      <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#faf6f0] mb-6 leading-tight" data-id="element-163">
        "Baby Only Sleeps In My Arms"
        <br data-id="element-164" />
        <span className="text-[#c9a96e]" data-id="element-165">Emergency Night Protocol</span>
      </h2>
      <p className="text-lg text-[#d4cfc5] mb-12 max-w-lg mx-auto" data-id="element-166">
        (0–12 Weeks)
      </p>

      <div className="relative mb-12 group" data-id="element-167">
        <div className="absolute inset-0 bg-[#c9a96e] opacity-5 blur-2xl rounded-full transform scale-90 group-hover:scale-100 transition-transform duration-700" data-id="element-168"></div>
        <img src="https://cdn.magicpatterns.com/uploads/9Bq7sPCfAAwFiYxEkykq9Q/heylloyd-image-1771111670446.png" alt="Emergency Night Protocol on Tablet" className="relative mx-auto w-full max-w-xs md:max-w-sm rounded-lg shadow-2xl transform group-hover:-translate-y-2 transition-transform duration-500" data-id="element-169" />
      </div>

      <div className="text-left space-y-6 text-lg md:text-xl text-[#f5f0e8] leading-relaxed mb-12" data-id="element-170">
        <p data-id="element-171">This is not a philosophy. It's not "sleep training."</p>
        <p data-id="element-172">
          It's a crisis-night operating system for newborn sleep—built for the
          exact moment when you can't think straight.
        </p>
        <p className="font-bold text-[#faf6f0]" data-id="element-173">You get:</p>
        <ul className="space-y-4" data-id="element-174">
          {['A 35–55 page PDF that reads like an emergency playbook', 'The Boil-to-Bassinet Ladder (a decision ladder so you always know the next move)', 'The Transfer Window method (how to time the release)', 'A 7-step transfer script (the exact sequence: what to do with your hands, and when)', 'Two printable Night Ladder sheets you can keep on your nightstand', 'A 14-night tracker that turns chaos into progress you can see'].map((item, i) => <li key={i} className="flex items-start" data-id="element-175">
              <span className="text-[#c9a96e] mr-3 mt-1" data-id="element-176">✓</span>
              <span data-id="element-177">{item}</span>
            </li>)}
        </ul>
      </div>

      <CTAButton data-id="element-178">Get the Emergency Night Protocol — $6.36</CTAButton>
    </Section>;
}